﻿import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


import { AuthenticationService } from '../services/authentication.service';
import { Signin } from '../services/signin';

declare var alertify: any
alertify.set('notifier', 'position', 'top-right');


@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent extends Signin implements OnInit {

   public spinnerIcon: boolean = false;

    constructor(public router: Router, public authenticationService: AuthenticationService) {
        super(router, authenticationService);
    }

    public toggleSpinnerIcon(): void {
        this.spinnerIcon === false ? this.spinnerIcon = true : this.spinnerIcon = false;
        let hideSpinnerIcon = setTimeout(() => {  
          this.spinnerIcon === true ? this.spinnerIcon = false : this.spinnerIcon = false;
          clearTimeout(hideSpinnerIcon)
        }, 2000);
    }

    public forgotPassword(): void {
       let msg = "Venligst kontakt administrator";
       alertify.warning(msg, 4, function () { });
    }

  ngOnInit(): void {
    
  }
}
